import {
	MAINTENANCE_INSTANCE_REQUEST_GET,
	MAINTENANCE_INSTANCE_RESPONSE_GET_SUCCESS,
	MAINTENANCE_INSTANCE_RESPONSE_GET_FAIL,
	ANNOUNCEMENT_BANNER_CLOSE_TRIGGER,
	RESET_ANNOUNCEMENT_BANNER_CLOSE
} from '../constants/maintenanceInstanceConstants';

export const maintainanceInstanceListReducer = (
	state = { maintenanceInstances: {} },
	action
) => {
	switch (action.type) {
		case MAINTENANCE_INSTANCE_REQUEST_GET:
			return {
				...state,
				loading: true,
			};
		case MAINTENANCE_INSTANCE_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				maintenanceInstances: action.payload,
			};
		case MAINTENANCE_INSTANCE_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
export const announcementBannerCloseTriggerReducer = (
	state = { announcementBannerClose: false },
	action
) => {
	switch (action.type) {
		case ANNOUNCEMENT_BANNER_CLOSE_TRIGGER:
			return {
				announcementBannerClose: action.payload
			};
		case RESET_ANNOUNCEMENT_BANNER_CLOSE:
			return {
				announcementBannerClose: false
			};
		default:
			return state;
	}
};
